import { IHttpClient } from '@micro-frontend-react/employee-experience/lib/IHttpClient';
import { put, getContext, all, takeLatest, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { ComponentsActionType, IRequestComponentsAction } from './Components.action-types';
import { receiveComponents } from './Components.actions';

export function* fetchComponents(): SagaIterator {
  const httpClient: IHttpClient = yield getContext('httpClient');

  try {
    const { data } = yield call([httpClient, httpClient.request], {
      url: `${__API_BASE_URL__}/components`,
      resource: __API_RESOURCE__,
    });

    yield put(receiveComponents(data));
  } catch {}
}

export function* componentsSagas(): SagaIterator {
  yield all([takeLatest(ComponentsActionType.REQUEST_COMPONENTS, fetchComponents)]);
}
